import { paintIconAction } from './82-icon-actions.mjs';
/** Move the same live card into a native modal presentation, preserving its
 * board, seed, score and keyed controls. Closing restores its feed position.
 * Native dialog supplies focus containment and Escape; no fullscreen API or
 * orientation permission is required on mobile Safari. */
export function createGameImmersion(ctx, host, board, { standalone = false } = {}) {
  // A dedicated game page already owns its canvas; direct touch does not need
  // an extra Expand decision. Embedded feed cards continue to preserve scroll.
  if (standalone) {
    host.dataset.immersive = 'true';
    board.dataset.immersive = 'true';
  }
  const button = ctx.e('button', 'game-expand', '⛶');
  button.type = 'button';
  paintIconAction(ctx, button, 'maximize-2', 'Expand game');
  const modal = ctx.e('dialog', 'game-immersion');
  modal.setAttribute('aria-label', 'Expanded game');
  const placeholder = ctx.e('span', 'game-immersion-placeholder');
  let open = false;
  function restore() {
    if (!open) return;
    open = false;
    placeholder.replaceWith(host);
    if (standalone) {
      host.dataset.immersive = 'true';
      board.dataset.immersive = 'true';
    } else {
      delete host.dataset.immersive;
      delete board.dataset.immersive;
    }
    paintIconAction(ctx, button, 'maximize-2', 'Expand game');
    button.focus?.({ preventScroll: true });
  }
  function toggle() {
    if (open) {
      modal.close();
      return;
    }
    if (typeof modal.showModal !== 'function') return;
    host.replaceWith(placeholder);
    modal.append(host);
    document.body.append(modal);
    host.dataset.immersive = 'true';
    board.dataset.immersive = 'true';
    open = true;
    paintIconAction(ctx, button, 'x', 'Close expanded game');
    try {
      modal.showModal();
      button.focus();
    } catch {
      restore();
    }
  }
  button.addEventListener('click', toggle);
  modal.addEventListener('close', restore);
  return {
    button,
    dispose() {
      if (open) {
        modal.close();
        restore();
      }
      button.removeEventListener('click', toggle);
      modal.removeEventListener('close', restore);
      modal.remove();
    },
  };
}
